import { useMemo } from 'react';

/**
 * Hook to get all assigned installation members for a project team.
 * Polinaidu: 24-04-2026 (17:25) - Created hook to provide all assigned team members for task assignment
 */
export const useProjectTeamMembers = (project) => {
  const members = useMemo(() => {
    if (!project?.fieldOfficers) return [];
    return project.fieldOfficers.filter(o => o && typeof o === 'object' && o._id);
  }, [project?.fieldOfficers]);

  return {
    members,
    count: members.length
  };
};
